/**
 * ContentTable the class to rendered rich text contents table.
 * @example <contents-table></contents-table>
 */
class ContentTable extends HTMLElement {
  /**
   * The constructor method is a special method of a class for creating
   * and initializing an object instance of that class.
   */
  constructor() {
    super();
    const headingList = document.querySelectorAll(
      '[rich-text-heading]'
    );
    this.contentList = this.querySelector('.content-table__list');

    this.parentSection = this.closest('section');
    if (this.parentSection)
      this.parentSection.dataset.contentsTableEmpty = `${headingList.length === 0}`;

    const template = this.querySelector('template');
    if (!headingList.length || !template) return;
    this.template = template?.cloneNode(true);
    template.remove();
    this.headingList = [...headingList];
    this.render();
  }

  /**
   * The render method is for render link list of rich text heading.
   * @name render
   * @kind function
   */
  render() {
    const headingList = this.headingList.map((element) => {
      const heading = element.getAttribute('rich-text-heading');
      const { id } = element;
      return { heading: `${heading}`, id: `${id}` };
    });

    headingList.forEach(({ heading, id }, index) => {
      if (!heading || !id) return;
      const content = this.template.innerHTML
        .replace(/\[\[heading\]]/g, `${index + 1}. ${heading}`)
        .replace(/\[\[id\]]/g, id);

      this.contentList.insertAdjacentHTML('beforeend', content);
    });

    const headingListNotEmpty = headingList.filter(({ heading }) => heading !== '');

    if (!this.parentSection) return;

    this.parentSection.dataset.contentsTableEmpty = `${headingListNotEmpty.length === 0}`;

    if (headingListNotEmpty.length > 0)
      this.parentSection.classList.add('content-table--ready');
  }
}
customElements.define('content-table', ContentTable);
